import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './RyanResetPasswordPage.css';

const RyanResetPasswordPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();

  const [checking, setChecking] = useState(true);
  const [tokenValid, setTokenValid] = useState(false);
  const [tokenError, setTokenError] = useState('');

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setTokenError('Token não encontrado.');
      setChecking(false);
      return;
    }
    fetch(`/api/ryan/auth/reset-password/${token}`)
      .then(r => r.json())
      .then(data => {
        if (data.valid) {
          setTokenValid(true);
        } else {
          setTokenError(data.reason || 'Link inválido ou expirado.');
        }
      })
      .catch(() => setTokenError('Erro ao verificar o link. Tente novamente.'))
      .finally(() => setChecking(false));
  }, [token]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 6) { setError('A senha deve ter pelo menos 6 caracteres.'); return; }
    if (newPassword !== confirmPassword) { setError('As senhas não coincidem.'); return; }

    setSubmitting(true);
    try {
      const res = await fetch(`/api/ryan/auth/reset-password/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ newPassword }),
      });
      const data = await res.json();
      if (res.ok) {
        setSuccess(true);
      } else {
        setError(data.message || 'Erro ao redefinir senha.');
      }
    } catch {
      setError('Erro de conexão. Tente novamente.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="rrp-root">
      <div className="rrp-card">
        <img src="/graia-logo.png" alt="Graia" className="rrp-logo" />
        <h1 className="rrp-title">Ryan</h1>

        {checking ? (
          <div className="rrp-loader">
            <div className="rrp-spinner" />
          </div>
        ) : !tokenValid ? (
          <div className="rrp-state">
            <p className="rrp-subtitle">Link inválido</p>
            <p className="rrp-state-msg rrp-state-msg--error">{tokenError}</p>
            <Link to="/ryan/login" className="rrp-link-back">← Voltar ao login</Link>
          </div>
        ) : success ? (
          <div className="rrp-state">
            <p className="rrp-subtitle">Senha redefinida!</p>
            <p className="rrp-state-msg rrp-state-msg--success">
              Sua senha foi atualizada com sucesso. Faça login com a nova senha.
            </p>
            <Link to="/ryan/login" className="rrp-btn-primary">Ir para o login</Link>
          </div>
        ) : (
          <>
            <p className="rrp-subtitle">Redefinir senha</p>
            <form className="rrp-form" onSubmit={handleSubmit}>
              {error && <div className="rrp-error">{error}</div>}
              <div className="rrp-field">
                <label className="rrp-label">Nova senha</label>
                <input
                  type="password"
                  className="rrp-input"
                  placeholder="Mínimo 6 caracteres"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  required
                  autoFocus
                />
              </div>
              <div className="rrp-field">
                <label className="rrp-label">Confirmar nova senha</label>
                <input
                  type="password"
                  className="rrp-input"
                  placeholder="Repetir nova senha"
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="rrp-btn" disabled={submitting}>
                {submitting ? 'Salvando…' : 'Redefinir senha'}
              </button>
            </form>
            <Link to="/ryan/login" className="rrp-link-back">← Voltar ao login</Link>
          </>
        )}
      </div>
    </div>
  );
};

export default RyanResetPasswordPage;
